import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import Card from "components/Card";
import Text from "components/Text";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";
import { addBackupStaff } from "repositories/leave-repository";
import toast from "react-hot-toast";
import styles from "./../StaffListingLeaves.module.scss";
import BackupStaffModal from "../../Leaves/component/BackupStaffModal";
import TemporaryStaffModal from "../../Leaves/component/TemporaryStaffModal";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import RedAlertInfo from "../../../../assets/images/red_alert_info.svg";
import CancellationModal from "./CancellationModal";
import { Link } from "react-router-dom";
import constants from "../../../../constants";
import { encodeId, setStorage } from "utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const leaveListTypeStatus = constants.LeaveTypeStatus;
const leaveListStatus = constants.LeaveStatus;
const LeavesTaskCard = ({
  t,
  leaveDetail,
  key,
  handleAcceptRejectLeave,
  checkBoxOnChange,
  checkBoxValue,
  checkBoxCheckedValue,
  officeId,
  onRefetch,
  handleCacellationLeave,
  handleArchiveUnaechiveLeave,
  handleEdit,
  selectedOwnerId,
}) => {
  const [isAddBackupStaff, setIsAddBackupStaff] = useState(false);
  const [backupStaffRadio, setBackupStaffRadio] = useState(1);
  const [isClickedOnChangeButton, setIsClickedOnChangeButton] = useState(false);
  const [isBackupStaffModalOpen, setIsBackupStaffModalOpen] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [isTemporaryStaffModalOpen, setIsTemporaryStaffModalOpen] =
    useState(false);
  const history = useHistory();
  const radioHandler = (backupStaffRadioValue) => {
    setBackupStaffRadio(backupStaffRadioValue);
  };
  const closeModal = () => setConfirmPopup(false);
  useEffect(() => {
    if (leaveDetail?.status !== leaveListStatus[1].value) {
      setIsTemporaryStaffModalOpen(false);
      setIsBackupStaffModalOpen(false);
      setIsAddBackupStaff(false);
      setIsClickedOnChangeButton(false);
    }
  }, [leaveDetail?.status]);

  const handleStaffLeaveListStatus = (statusId) => {
    switch (statusId) {
      case leaveListStatus[1].value:
        return <span className={styles["pending"]}>{t("pending")}</span>;
      case leaveListStatus[2].value:
        return (
          <span className={styles["approved"]}>
            {" "}
            {t("staffTimesheet.approved")}{" "}
          </span>
        );
      case leaveListStatus[3].value:
        return <span className={styles["rejected"]}>{t("rejected")}</span>;
      case leaveListStatus[4]?.value:
        return <span className={styles["withdrawn"]}>{t("Withdrawn")}</span>;
      case leaveListStatus[5]?.value:
        return <span className={styles["rejected"]}>{t("Cancelled")}</span>;
      case leaveListStatus[6]?.value:
        return (
          <span className={styles["cancellationPending"]}>
            {" "}
            {t("staffTimesheet.cancellationPending")}{" "}
          </span>
        );

      default:
        return null;
    }
  };
  const handleStaffLeaveTypeStatus = (leaveType) => (
    <>
      {leaveType === leaveListTypeStatus[1]?.value && (
        <span>{t("staffLeaves.casual")}</span>
      )}
      {leaveType === leaveListTypeStatus[2]?.value && (
        <span>{t("staffLeaves.medical")}</span>
      )}
      {leaveType === leaveListTypeStatus[3]?.value && (
        <span>{t("staffLeaves.vacation")}</span>
      )}
    </>
  );

  const addBackupStaffMember = async (name, contactNumber, userId) => {
    try {
      let params = {
        leaveId: leaveDetail?.id,
        backupUserId: userId,
        backupName: name,
        backupContactNumber: contactNumber,
      };

      let res = await addBackupStaff(params);
      toast.success(res.message);
      onRefetch();
      setIsTemporaryStaffModalOpen(false);
      setIsBackupStaffModalOpen(false);
      setIsAddBackupStaff(false);
      setIsClickedOnChangeButton(false);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const isPastDate = moment(leaveDetail?.startDate).isBefore(
    moment().startOf("day")
  );

  const hanldeRedirectToScheduler = () => {
    setStorage("IsFromLeaveSchedule", {
      isFromleaveConflict: true,
      startDate: leaveDetail?.startDate,
      endDate: leaveDetail?.endDate,
      userID: leaveDetail?.userId,
      userName: leaveDetail?.name,
      officeId: officeId,
      ownerID: selectedOwnerId,
    });
    setStorage("isFromOwnerOfficeModule", {
      officeSlection: false,
      staffOfficeSlection: false,
      isAdminControl: false,
      officeId: null,
    });
    history.push({ pathname: constants.routes.scheduler.calendar });
  };
  return (
    <div key={key}>
      <Card
        className={styles["leaves-task-card"]}
        radius="10px"
        marginBottom="10px"
        shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
        cursor="default"
      >
        {leaveDetail?.comment && leaveDetail?.isCancellationReject && (
          <div className={styles.red_info_container}>
            <div className={styles.info_img_text}>
              <img src={RedAlertInfo} alt="RedAlertInfo" />
              <p className={styles.info_text}>
                {t("staffLeaves.leaveCancellationRequest")}
              </p>
            </div>
            <p
              className={styles.click_text}
              onClick={() => setConfirmPopup(true)}
            >
              {t("staffLeaves.clickForReason")}
            </p>
          </div>
        )}
        <div
          className={
            "d-flex justify-content-between mb-3" +
            " " +
            styles["inner-content"]
          }
        >
          {leaveDetail?.status === leaveListStatus[1].value ? (
            <div className={"ch-checkbox " + styles["checkbox-color"]}>
              <label>
                <input
                  type="checkbox"
                  value={checkBoxValue}
                  checked={checkBoxCheckedValue}
                  onChange={(e) => checkBoxOnChange(e)}
                />
                <span>{leaveDetail?.name ? leaveDetail?.name : "--"}</span>
              </label>
            </div>
          ) : (
            <div className={styles["name"]}>
              <Text size="16px" weight="600" color="#587E85">
                {leaveDetail?.name ? leaveDetail?.name : "--"}
              </Text>
            </div>
          )}
          <div className={styles.status_dot_wrapper}>
            <div className={styles["approval-status"] + " " + "m-0"}>
              {leaveDetail?.status
                ? handleStaffLeaveListStatus(leaveDetail.status)
                : "--"}
            </div>

            <UncontrolledDropdown>
              <DropdownToggle
                caret={false}
                tag="div"
                className="cursor-pointer"
              >
                <div className={styles["ellipsis-icon"]}>
                  <ThreeDotsVertical />
                </div>
              </DropdownToggle>
              <DropdownMenu end className={styles["office-dropdown-menu"]}>
                {!leaveDetail?.archiveStatus && (
                  <DropdownItem className={styles["office-dropdown-item"]}>
                    <p
                      className="m-0"
                      onClick={() =>
                        handleArchiveUnaechiveLeave(leaveDetail, "Archive")
                      }
                    >
                      Archive
                    </p>
                  </DropdownItem>
                )}

                <DropdownItem className={styles["office-dropdown-item"]}>
                  <Link
                    className="m-0"
                    to={constants.routes.staff.leavesHistoryLogs.replace(
                      ":leaveId",
                      encodeId(leaveDetail?.id)
                    )}
                  >
                    View History Log
                  </Link>
                </DropdownItem>

                {leaveDetail?.archiveStatus > 0 && (
                  <DropdownItem className={styles["office-dropdown-item"]}>
                    <p
                      className="m-0"
                      onClick={() =>
                        handleArchiveUnaechiveLeave(leaveDetail, "UnArchive")
                      }
                    >
                      Unarchive
                    </p>
                  </DropdownItem>
                )}

                {leaveDetail?.status === 1 && !isPastDate && (
                  <DropdownItem className={styles["office-dropdown-item"]}>
                    <p className="m-0" onClick={() => handleEdit(leaveDetail)}>
                      Edit
                    </p>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
        <div className={styles["content-box"]}>
          <Row>
            <Col sm="3" xs="6">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.from")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {leaveDetail?.startDate
                  ? moment(leaveDetail.startDate).format("ll")
                  : "--"}
              </Text>
            </Col>
            <Col sm="3" xs="6">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.to")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {leaveDetail?.endDate
                  ? moment(leaveDetail.endDate).format("ll")
                  : "--"}
              </Text>
            </Col>
            <Col sm="3" xs="6">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.duration")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {leaveDetail?.duration ? `${leaveDetail.duration} Days` : "--"}
              </Text>
            </Col>
            <Col sm="3" xs="6">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.leaveType")}
              </Text>
              <Text
                size="14px"
                marginBottom="25px"
                weight="600"
                color="#102c42"
              >
                {leaveDetail?.leaveType
                  ? handleStaffLeaveTypeStatus(leaveDetail.leaveType)
                  : "--"}
              </Text>
            </Col>
            <Col sm="12" xs="12" className="mb-2">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.backupStaffMember")}
              </Text>
              {leaveDetail?.status !== leaveListStatus[1].value ? (
                <>
                  {leaveDetail?.backupName ? (
                    <>
                      <Text
                        size="14px"
                        marginBottom="25px"
                        weight="600"
                        color="#102c42"
                      >
                        <span className="d-block">
                          {leaveDetail?.backupName}
                        </span>
                        <span className="d-block">
                          {leaveDetail?.backupContactNumber}
                        </span>
                      </Text>
                    </>
                  ) : (
                    <Text
                      size="14px"
                      marginBottom="9px"
                      weight="600"
                      color="#102c42"
                    >
                      <span>{t("staffLeaves.noStaffAdded")}</span>
                    </Text>
                  )}
                </>
              ) : (
                <>
                  {leaveDetail?.backupUserId ? (
                    <>
                      {!isClickedOnChangeButton && (
                        <>
                          <div className="d-flex flex-column">
                            <Text
                              className="d-inline-block"
                              size="14px"
                              marginBottom="25px"
                              weight="600"
                              color="#102c42"
                            >
                              <span className="d-block">
                                {leaveDetail?.backupUserName}
                              </span>
                              <span className="d-block">
                                {leaveDetail?.backupUserContactNumber}
                              </span>
                            </Text>
                            <span
                              className="text-decoration-link mb-2"
                              onClick={() => {
                                setIsAddBackupStaff(true);
                                setIsClickedOnChangeButton(true);
                              }}
                            >
                              {t("change")}
                            </span>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {leaveDetail?.backupName ? (
                        <>
                          {!isClickedOnChangeButton && (
                            <>
                              <div className="d-flex flex-column">
                                <Text
                                  className="d-inline-block"
                                  size="14px"
                                  weight="600"
                                  color="#102c42"
                                >
                                  <span className="d-block">
                                    {leaveDetail?.backupName}
                                  </span>
                                  <span className="d-block">
                                    {leaveDetail?.backupContactNumber}
                                  </span>
                                </Text>
                                <span
                                  className="text-decoration-link mb-2"
                                  onClick={() => {
                                    setIsAddBackupStaff(true);
                                    setIsClickedOnChangeButton(true);
                                  }}
                                >
                                  {t("change")}
                                </span>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <div className="ch-checkbox">
                          <label className="pb-2 mb-0 pt-0">
                            <input
                              type="checkbox"
                              name="promocodes"
                              onChange={(e) =>
                                setIsAddBackupStaff(!isAddBackupStaff)
                              }
                            />
                            <span> {t("staffLeaves.addBackupStaff")} </span>
                          </label>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              {isAddBackupStaff && (
                <>
                  <div
                    className={
                      "d-flex yellow-alert-box w-100 w-md-50 mb-4 rounded-0 mt-0"
                    }
                  >
                    {t("staffLeaves.selectBackupText")}
                  </div>
                  <div className="d-flex justify-content-between w-100 w-md-50">
                    <div className="ch-radio">
                      <label className="mr-5" onClick={(e) => radioHandler(1)}>
                        <input
                          type="radio"
                          name="sendPromoCodeTo"
                          checked={backupStaffRadio === 1}
                          onChange={() => {}}
                        />
                        <span> {t("staffLeaves.internalTempList")} </span>
                      </label>
                    </div>
                    {backupStaffRadio === 1 && (
                      <span
                        className="link-btn py-2 pb-3 pb-md-0"
                        onClick={() => {
                          setIsTemporaryStaffModalOpen(true);
                        }}
                      >
                        {leaveDetail?.backupUserName || leaveDetail?.backupName
                          ? t("staffLeaves.change")
                          : t("staffLeaves.selectStaff")}
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-between w-100 w-md-50">
                    <div className="ch-radio">
                      <label
                        className="pb-2 pt-3"
                        onClick={(e) => radioHandler(2)}
                      >
                        <input
                          type="radio"
                          name="sendPromoCodeTo"
                          checked={backupStaffRadio === 2}
                          onChange={() => {}}
                        />
                        <span>{t("staffLeaves.addBackupStaffManually")}</span>
                      </label>
                    </div>
                    {backupStaffRadio === 2 && (
                      <span
                        className="link-btn py-2"
                        onClick={() => {
                          setIsBackupStaffModalOpen(true);
                        }}
                      >
                        {leaveDetail?.backupUserName || leaveDetail?.backupName
                          ? t("staffLeaves.change")
                          : t("staffLeaves.selectStaff")}
                      </span>
                    )}
                    <div className="d-none">
                      <span className="link-btn py-2">
                        {" "}
                        {t("staffLeaves.change")}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </Col>
            <Col sm="12" xs="12">
              <Text size="12px" marginBottom="5px" weight="400" color="#6f7788">
                {t("staffLeaves.reasonForLeave")}
              </Text>
              <Text size="14px" weight="600" color="#102c42" break>
                {leaveDetail?.reason ? leaveDetail?.reason : "--"}
              </Text>
            </Col>
            {leaveDetail?.comment && (
              // && [3].includes(leaveDetail?.status)
              <Col sm="12" xs="12">
                <Text
                  size="12px"
                  marginBottom="5px"
                  marginTop="15px"
                  weight="400"
                  color="#6f7788"
                >
                  {t("staffLeaves.reason")}
                </Text>
                <Text size="14px" weight="600" color="#102c42" break>
                  {leaveDetail?.comment ? leaveDetail?.comment : "--"}
                </Text>
              </Col>
            )}
          </Row>
          {leaveDetail?.status === leaveListStatus[1].value && (
            <>
              <button
                className={
                  "button button-round button-shadow mr-md-4 w-sm-100  mb-md-0 " +
                  styles["btn-top"]
                }
                title={t("staffLeaves.approve")}
                onClick={() =>
                  handleAcceptRejectLeave(leaveDetail, true, "Accept")
                }
              >
                {t("staffLeaves.approve")}
              </button>
              <button
                className={
                  "button button-round button-border btn-mobile-link button-dark " +
                  styles["reject-btn"]
                }
                title={t("reject")}
                onClick={() =>
                  handleAcceptRejectLeave(leaveDetail, false, "Reject")
                }
              >
                {t("reject")}
              </button>
            </>
          )}
          {leaveDetail?.status === leaveListStatus[6].value && (
            <>
              <button
                className={
                  "button button-round button-shadow mr-md-4 w-sm-100  mb-md-0 " +
                  styles["btn-top"]
                }
                title={t("staffLeaves.approve")}
                onClick={() => handleCacellationLeave(leaveDetail, "Accept")}
              >
                {t("staffLeaves.approveCancellation")}
              </button>
              <button
                className={
                  "button button-round button-border btn-mobile-link button-dark " +
                  styles["reject-btn"]
                }
                title={t("reject")}
                onClick={() => handleCacellationLeave(leaveDetail, "Reject")}
              >
                {t("staffLeaves.rejectCancellation")}
              </button>
            </>
          )}
          {leaveDetail?.isConflictingLeave === 1 ? (
            <div className={styles.red_info_container + " mt-3"}>
              <div className={styles.info_img_text}>
                <img src={RedAlertInfo} alt="RedAlertInfo" />
                <p className={styles.info_text}>
                  {t("staffLeaves.leaveConflictIndicator")}
                </p>
              </div>
              <p
                className={styles.click_text}
                onClick={() => {
                  hanldeRedirectToScheduler();
                }}
              >
                {t("staffLeaves.clicktoSeeFullSchedule")}
              </p>
            </div>
          ) : (
            <button
              className="link-btn border-0 bg-transparent"
              onClick={() => {
                hanldeRedirectToScheduler();
              }}
            >
              {t("staffLeaves.viewSchedule")}
            </button>
          )}
        </div>
      </Card>
      {isBackupStaffModalOpen && (
        <BackupStaffModal
          isBackupStaffModalOpen={isBackupStaffModalOpen}
          setIsBackupStaffModalOpen={setIsBackupStaffModalOpen}
          handleAdd={(name, contactNo) => addBackupStaffMember(name, contactNo)}
        />
      )}
      {isTemporaryStaffModalOpen && (
        <TemporaryStaffModal
          isTemporaryStaffModalOpen={isTemporaryStaffModalOpen}
          setIsTemporaryStaffModalOpen={setIsTemporaryStaffModalOpen}
          officeId={+officeId}
          leaveId={leaveDetail?.id}
          toDate={moment(leaveDetail?.endDate).format("YYYY-MM-DD")}
          fromDate={moment(leaveDetail?.startDate).format("YYYY-MM-DD")}
          handleAdd={(selectedData) =>
            addBackupStaffMember(
              `${selectedData.firstName} ${selectedData.lastName}`,
              selectedData.contactNumber,
              selectedData.userId
            )
          }
        />
      )}

      {confirmPopup && (
        <CancellationModal
          t={t}
          isModalOpen={confirmPopup}
          closeModal={closeModal}
          leaveDetail={leaveDetail}
        />
      )}
    </div>
  );
};

export default withTranslation()(LeavesTaskCard);
